var map = {
	"./en": [
		"f334",
		"lang-en"
	],
	"./en.js": [
		"f334",
		"lang-en"
	],
	"./zh-CN": [
		"5b6f"
	],
	"./zh-CN.js": [
		"5b6f"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a151";
module.exports = webpackAsyncContext;